import { FunctionComponent, h } from "preact"
import { Role, RoleList } from "../../../enum/roles.enum"

import { AxiosApiError } from "../../../types/api-response"
import { Button } from "../../../parts/buttons"
import { User } from "../../../types/user"
import { mutate } from "swr"
import useAllCompany from "../../../hooks/useAllCompany"
import useAuth from "../../../hooks/useAuth"
import { useEffect } from "preact/hooks"
import useObjectState from "../../../hooks/useObjectState"
import Renderif from "../../../components/Renderif";

type NewUserProps = h.JSX.HTMLAttributes<HTMLDivElement> & {
  show: boolean
  userData: User
  onHide: () => void
}

const EditUser: FunctionComponent<NewUserProps> = ({ userData, show, onHide }) => {
  const { data: companies } = useAllCompany()
  const defaultState = {
    name: userData.name,
    email: userData.email,
    role: userData.role,
    company: { uuid: userData.company?.uuid },
    mil: { uuid: userData.mil?.uuid },
    notification: userData.notification,
    notification_interval: 6,
  }

  const [user, setUser] = useObjectState(defaultState)
  const { fetcher } = useAuth()

  useEffect(() => {
    setUser(defaultState)
  }, [userData])

  const handleSubmit = () => {
    let reqBody: any = { ...user }
    if (!user?.company?.uuid) reqBody = { ...reqBody, company: null }
    if (!user?.mil?.uuid) reqBody = { ...reqBody, mil: null }

    fetcher()
      .patch("/user/" + userData.uuid, reqBody)
      .then(() => {
        if (onHide) onHide()
        setUser(defaultState)
        mutate("/user")
      })
      .catch((e: AxiosApiError) => {
        const msg = e.response?.data?.data?.message || e.response?.data?.message || "Server Error"
        if (alert) {
          if (Array.isArray(msg)) alert(msg.map((t) => "- " + t).join("\n"))
          else alert(msg)
        }
      })
  }
  const handleCancel = () => {
    setUser(defaultState)
    if (onHide) onHide()
  }
  return (
    <div
      className="modal-backdrop"
      style={{
        display: show ? "inherit" : "none",
        backgroundColor: "#00000099",
        overflowY: "auto",
      }}
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content card">
          <div className="card-body d-flex justify-content-between">
            <h5 class="card-title">Edit User</h5>
            <div>
              <Button variant="primary" onClick={handleSubmit}>
                Save
              </Button>
              <Button variant="tertiary" className="ms-2" onClick={handleCancel}>
                Cancel
              </Button>
            </div>
          </div>
          <div className="card-body px-4">
            <div class="form-group pb-2">
              <label>Name</label>
              <input
                value={user.name}
                required
                type="text"
                class="form-control"
                onChange={({ currentTarget }) => {
                  setUser({ name: currentTarget.value })
                }}
              />
            </div>
            <div class="form-group pb-2 ">
              <label>Email</label>
              <input
                value={user.email}
                required
                type="email"
                class="form-control"
                onChange={({ currentTarget }) => {
                  setUser({ email: currentTarget.value })
                }}
              />
            </div>
            <div class="form-group pb-2">
              <label>Role</label>
              <select
                name=""
                value={user.role}
                className="rounded-pill form-control"
                onChange={({ currentTarget }) => {
                  setUser({ role: currentTarget.value as Role })
                }}
                id=""
              >
                {RoleList?.map((role) => (
                  <option key={role} value={role}>
                    {role}
                  </option>
                ))}
              </select>
            </div>
            <div class="form-group pb-2">
              <label>Affiliate</label>
              <select
                name=""
                className="rounded-pill form-control"
                value={user.company.uuid || ""}
                id=""
                onChange={({ currentTarget }) => {
                  setUser({ company: { uuid: currentTarget.value }, mil: { uuid: "" } })
                }}
              >
                {userData?.role == "ADMIN" && <option value="">HQ</option>}
                {companies?.map(({ uuid, name }) => (
                  <option key={uuid} value={uuid}>
                    {name}
                  </option>
                ))}
              </select>
            </div>
            {user?.company?.uuid && (
              <div class="form-group pb-2">
                <label>Mills</label>
                <select
                  name=""
                  className="rounded-pill form-control"
                  value={user.mil.uuid}
                  id=""
                  onChange={({ currentTarget }) => {
                    setUser({ mil: { uuid: currentTarget.value } });
                  }}
                >
                  <Renderif isTrue={user.role !== Role.Member && user.role !== Role.Operator}>
                    <option value="">All Mills</option>
                  </Renderif>
                  {companies
                    ?.find(({ uuid }) => uuid == user.company.uuid)
                    ?.mils?.map(({ uuid, name }) => (
                      <option key={uuid} value={uuid}>
                        {name}
                      </option>
                    ))}
                </select>
              </div>
            )}
            {/* {user?.company?.uuid && (
              <div class="form-group pb-2">
                <label>Mills</label>
                <select
                  name=""
                  className="rounded-pill form-control"
                  value={user.mil.uuid}
                  id=""
                  onChange={({ currentTarget }) => {
                    setUser({ mil: { uuid: currentTarget.value } })
                  }}
                >
                  {companies
                    ?.find(({ uuid }) => uuid == user.company.uuid)
                    ?.mils?.map(({ uuid, name }) => (
                      <option key={uuid} value={uuid}>
                        {name}
                      </option>
                    ))}
                </select>
              </div>
            )} */}
            <div class="form-group pb-2">
              <label>Notification</label>
              <select
                name=""
                className="rounded-pill form-control"
                value={user.notification ? "on" : "off"}
                id=""
                onChange={({ currentTarget }) => {
                  setUser({ notification: currentTarget.value == "on" })
                }}
              >
                <option value="on">On</option>
                <option value="off">Off</option>
              </select>
            </div>
            <div class="form-group pb-2 ">
              <label>Email Notification Interval</label>
              <input value={user.notification_interval + " Hours"} required type="text" disabled class="form-control" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EditUser
